import { humanize } from "web/services/inflector"

export default function useListType({
  listType,
  parentSubjectType,
  subjectType,
  topic,
}) {
  const hasParentSubject = parentSubjectType !== undefined
  const hasTopic = topic !== undefined

  let calculatedListType =
    listType ||
    (hasParentSubject ? `${parentSubjectType}_${subjectType}` : subjectType)

  if (hasTopic) calculatedListType += `_${topic.name}`

  const listTypeFriendlyName = hasTopic
    ? topic.label
    : humanize(
        (subjectType = subjectType === "deal_asset" ? "asset" : subjectType)
      )

  return { listType: calculatedListType, listTypeFriendlyName }
}
